import { supabase, CostoActividad } from '../lib/supabase';
import { solicitudActividadService } from './solicitudActividadService';

import type { RespaldoMovimiento } from '../types/comprobante';
import type { DatosEdicionCostoActividad } from '../utils/edicionCostoActividad';

export type CrearCostoActividad = DatosEdicionCostoActividad & { readonly actividad_id: string };

export const costoActividadService = {
  async getByActividad(actividadId: string): Promise<CostoActividad[]> {
    const { data, error } = await supabase
      .from('costos_actividad')
      .select('*')
      .eq('actividad_id', actividadId)
      .eq('anulado', false)
      .order('fecha', { ascending: false });

    if (error) throw error;
    return data || [];
  },

  async getById(id: string): Promise<CostoActividad | null> {
    const { data, error } = await supabase
      .from('costos_actividad')
      .select('*')
      .eq('id', id)
      .maybeSingle();

    if (error) throw error;
    return data;
  },

  async create(
    costo: CrearCostoActividad,
    respaldo: RespaldoMovimiento,
  ): Promise<CostoActividad> {
    const datos = {
      actividad_id: costo.actividad_id, descripcion: costo.descripcion, monto: costo.monto, fecha: costo.fecha,
      tipo_costo: costo.tipo_costo, producto_id: costo.producto_id || null, produccion_id: costo.produccion_id || null,
      requiere_reembolso: costo.requiere_reembolso ?? false, es_donacion: costo.es_donacion ?? false,
    };
    const id = crypto.randomUUID(); const movimiento = crypto.randomUUID();
    return solicitudActividadService.ejecutarContrato<CostoActividad>('crear_costo_actividad',
      { p_id: id, p_movimiento: movimiento, p_datos: datos, p_respaldo: respaldo }, { id, movimiento, datos, respaldo });
  },

  async update(id: string, cambios: Partial<DatosEdicionCostoActividad>): Promise<CostoActividad> {
    return solicitudActividadService.ejecutarContrato<CostoActividad>('editar_costo',
      { p_id: id, p_cambios: cambios }, { id, cambios });
  },

  async delete(id: string, motivo?: string): Promise<void> {
    const datos = { motivo: motivo || 'Gasto anulado', fecha_anulacion: new Date().toISOString() };
    await solicitudActividadService.ejecutarContrato<CostoActividad>('anular_costo_actividad',
      { p_id: id, p_datos: datos }, { id, datos });
  },

  async getTotalCostosByActividad(actividadId: string): Promise<number> {
    const { data, error } = await supabase
      .from('costos_actividad')
      .select('monto')
      .eq('actividad_id', actividadId)
      .eq('anulado', false);

    if (error) throw error;

    return data?.reduce((sum, c) => sum + Number(c.monto), 0) || 0;
  }
};
